import { CSSProperties, createElement } from "react";

type AnyProps = Record<string, any>;

const shopCartAreaStyle: CSSProperties = {
  border: "1px solid #DEE2E6",
  display: "flex",
  borderRadius: 8,
  gap: 4,
  alignItems: "center",
};

export const ShopCartArea = ({ children, style, ...props }: AnyProps) =>
  createElement(
    "div",
    {
      style: { ...shopCartAreaStyle, ...(style ?? {}) },
      ...props,
    },
    children
  );
